import { UseFormReturn } from "react-hook-form";
import { toast } from "@/lib/toast";

// Define the custom error code constant (match backend)
export const ENTITY_NAME_ALREADY_EXISTS = 'ENTITY_NAME_ALREADY_EXISTS';
export const STRIPE_ENTITY_NOT_FOUND = 'STRIPE_ENTITY_NOT_FOUND';

export const useFormConflictError = (
  form: UseFormReturn<any>,
  fieldMap: Record<string, string> = { 'default': 'name' }
) => {

  const handleConflictError = (error: any, fallbackMessage: string = "Es ist ein Fehler aufgetreten") => {
    // Check if it's our custom API error
    const apiError = error?.debugContext?.response?.body || error; 

    if (apiError?.error === ENTITY_NAME_ALREADY_EXISTS) {
       const targetField = fieldMap['default'] || 'name';
       
       form.setError(targetField, {
         type: "manual",
         message: "Dieser Name ist bereits vergeben." 
       });
       return;
    }

    if (apiError?.error === STRIPE_ENTITY_NOT_FOUND) {
        const targetField = apiError.field || 'stripeCustomerId';
        
        form.setError(targetField, {
          type: "manual",
          message: apiError.message || "Stripe ID nicht gefunden."
        });
        return;
     }

    // Fallback for other errors
    toast.error(apiError?.message || fallbackMessage, { error });
  };

  return { handleConflictError };
};
